import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import "../styles/WomenSchemes.css";

const WomenSchemes = () => {
  const [schemes, setSchemes] = useState([]);

  useEffect(() => {
    const fetchWomenSchemes = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "women_schemes"));
        const fetchedSchemes = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        console.log("🔥 Fetched Women Schemes:", fetchedSchemes); // Debugging

        setSchemes(fetchedSchemes);
      } catch (error) {
        console.error("❌ Error fetching women's schemes:", error);
      }
    };

    fetchWomenSchemes();
  }, []);

  return (
    <div className="women-schemes-container">
      <h2>Government Schemes for Women</h2>
      {schemes.length === 0 ? (
        <p>No schemes available.</p>
      ) : (
        <ul>
          {schemes.map((scheme) => (
            <li key={scheme.id} className="scheme-card">
              <h3>{scheme.name}</h3>
              <p><strong>Description:</strong> {scheme.description}</p>
              <p><strong>Documents Required:</strong> {scheme.documents}</p>
              <p><strong>Valid Time Period:</strong> {scheme.ValidTime}</p>
              <p><strong>State Availability:</strong> {scheme["State Availability"]}</p>
              <p><strong>Gender :</strong> {scheme.Gender}</p>
              <p><strong>Hospitality Available:</strong> {scheme.Hospitality}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default WomenSchemes;
